
import {Component, Vue, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";
import { ROWS_PER_PAGE } from "@/utils/constants";

@Component
export default class BillingActivity extends Vue {
    @Getter private currentUser: any;

    private payments: any[] = [];
    private headers: object[] = [
        {value: "createdAt", sortable: false},
        {value: "status", sortable: false},
        {value: "key", sortable: false},
        {value: "subscription", sortable: false},
        {value: "paymentMethod", sortable: false},
        {value: "amount", sortable: false},
    ];
    private pagination: any = {
        page: 1,
        itemsPerPage: 15,
    };

    private ROWS_PER_PAGE = ROWS_PER_PAGE;

    private totalItems: number = 0;
    private loading: boolean = false;

    @Watch("pagination", { deep: true })
    public handler(): void {
        this.getPayments();
    }

    private getPayments(): Promise<any> {
        this.loading = true;
        return this.$store.dispatch("users/getPayments", {
            userId: this.currentUser.id,
            query:  this.pagination,
        }).then((res: { rows: any[], count: number }) => {
            this.totalItems = Number(res?.count);
            this.payments = res?.rows || [];
            this.loading = false;
        }).catch((err) => {
            this.$store.commit("alerts/displayError", {
                msg: err,
            });
        });
    }

    private printPayments() {
        // to print all payments
        this.pagination.itemsPerPage = -1;
        this.getPayments().then(() =>  window.print());

    }

    private getStatusColor(status: string): string {
        switch (status) {
            case "CREATED": return "blue";
            case "PAID": return "green";
            case "ERROR": return "red";
            default: return "default";
        }
    }

    private getStatusIcon(status: string): string {
        switch (status) {
            case "CREATED": return "send";
            case "PAID": return "check";
            case "ERROR": return "priority_high";
            default: return "";
        }
    }
}
